import { Button } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import moment from "moment";

import { MODAL_HANDLER } from "@/lib/Mantine";

export function AcceptTerms({ context, id }: ContextModalProps) {
  function handleAccept() {
    const date = moment();
    const expires = date.add(1, "years").toDate();

    document.cookie = `userTerm=accepted; expires=${expires.toUTCString()}; path=/`;
  }

  const handleClick = () => {
    handleAccept();
    context.closeModal(id);
  };

  const handleModal = () => {
    MODAL_HANDLER.terms(undefined, { withCloseButton: true });
  };

  return (
    <>
      <p className="text-center text-gray-600">
        Usamos cookies para personalizar conteúdos e melhorar a sua experiência.
        <p onClick={handleModal} className="cursor-pointer text-center font-semibold text-black underline" role="button">
          Termos de Uso
        </p>
      </p>

      <Button onClick={handleClick} color="primary" mt="md" fullWidth>
        Entendi e aceito
      </Button>
    </>
  );
}
